import * as icons from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router-dom";
import styles from "./PageTitleComponent.module.scss"
export default function PageTitleComponent(props: PageTitleComponentProps) {
    const navigate = useNavigate();

    function goBack() {
        navigate(props.backUrl!);
    }

    return (
        <div className={`${styles.wrapper} page-title`}>
            {props.backUrl != null &&
                <div className={styles.back_button} onClick={goBack}>
                    <FontAwesomeIcon icon={icons.faChevronLeft}/>
                </div>}
            <h1>{props.title}</h1>
        </div>
    )
}

export interface PageTitleComponentProps {
    title: string;
    backUrl?: string;
}